import React from 'react';
import { Check } from 'lucide-react';
export function BonusSection() {
  return <section className="py-10 bg-main" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-3">
          <span className="inline-block text-xs uppercase tracking-widest text-accent font-semibold mb-3" data-id="element-4">
            Incluido con tu acceso
          </span>
          <h2 className="text-3xl md:text-4xl font-serif text-title mb-4" data-id="element-5">
            Además del método, te llevas esto.
          </h2>
          <p className="text-lg text-body max-w-2xl mx-auto" data-id="element-6">
            Dos recursos para implementar desde el primer día, sin perderte y
            sin improvisar.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-7">
          {/* Card 1 */}
          <div className="bg-card border border-[#D9D0C1] shadow-sm rounded-sm overflow-hidden flex flex-col" data-id="element-8">
            <img src="https://cdn.magicpatterns.com/uploads/4QHPEnhgeYEtuda48wU6xj/metodo_bono_1_imagen.png" alt="Checklist de Lanzamiento Faceless" className="w-full h-auto object-cover border-b border-[#D9D0C1]" data-id="element-9" />
            <div className="p-6 md:p-8 flex-1 flex flex-col" data-id="element-10">
              <div className="mb-4" data-id="element-11">
                <span className="inline-block px-3 py-1 bg-accent/10 text-accent text-xs uppercase tracking-widest font-semibold rounded-sm" data-id="element-12">
                  BONO #1
                </span>
              </div>
              <h3 className="font-serif text-xl text-title mb-2" data-id="element-13">
                Checklist de Lanzamiento Faceless
              </h3>
              <p className="text-sm text-body italic mb-4" data-id="element-14">
                "Tu hoja de ruta para publicar tus primeros 5 contenidos sin
                mostrar tu cara."
              </p>
              <p className="text-sm text-body leading-relaxed mb-6" data-id="element-15">
                Checklist de 10 pasos (antes y después de publicar): qué
                preparar, qué revisar y qué ajustar para que cada post salga con
                intención y sin caos. En menos de 10 minutos tienes tu primer
                contenido listo.
              </p>

              <ul className="space-y-3 mb-6 flex-1" data-id="element-16">
                {['Publica sin dudar desde el primer día', 'Paso a paso: pre y post publicación', 'Ahorra tiempo (foco total)', 'Diseñado para cuentas sin rostro'].map((bullet, i) => <li key={i} className="flex items-start" data-id="element-17">
                    <div className="flex-shrink-0 w-5 h-5 rounded-full bg-alt flex items-center justify-center mt-0.5 mr-3 border border-[#D9D0C1]" data-id="element-18">
                      <Check size={12} className="text-accent" data-id="element-19" />
                    </div>
                    <span className="text-sm text-body" data-id="element-20">{bullet}</span>
                  </li>)}
              </ul>

              <div className="mt-auto pt-4 border-t border-[#D9D0C1]" data-id="element-21">
                <p className="text-xs text-body text-center" data-id="element-22">
                  PDF imprimible • Implementación en 10 minutos
                </p>
              </div>
            </div>
          </div>

          {/* Card 2 */}
          <div className="bg-card border border-[#D9D0C1] shadow-sm rounded-sm overflow-hidden flex flex-col" data-id="element-23">
            <img src="https://cdn.magicpatterns.com/uploads/vyi2MVLAs2drgXSHn1UKin/metodo_bono_2_imagen.png" alt="Guiones DM Faceless" className="w-full h-auto object-cover border-b border-[#D9D0C1]" data-id="element-24" />
            <div className="p-6 md:p-8 flex-1 flex flex-col" data-id="element-25">
              <div className="mb-4" data-id="element-26">
                <span className="inline-block px-3 py-1 bg-accent/10 text-accent text-xs uppercase tracking-widest font-semibold rounded-sm" data-id="element-27">
                  BONO #2
                </span>
              </div>
              <h3 className="font-serif text-xl text-title mb-2" data-id="element-28">
                Guiones DM Faceless (Copia y Pega)
              </h3>
              <p className="text-sm text-body italic mb-4" data-id="element-29">
                "Responde, filtra y cierra ventas por DM sin sonar agresiva y
                sin quedarte en blanco."
              </p>
              <p className="text-sm text-body leading-relaxed mb-6" data-id="element-30">
                12 guiones por situación: respuesta inicial, calificación y
                cierre. Para contestar con tono premium y natural, sin
                improvisar y manteniendo tu privacidad.
              </p>

              <ul className="space-y-3 mb-6 flex-1" data-id="element-31">
                {['12 guiones listos para copiar y pegar', 'Respuestas para objeciones sin presión', 'Cierre suave con privacidad primero', 'Tono premium, cercano y natural'].map((bullet, i) => <li key={i} className="flex items-start" data-id="element-32">
                    <div className="flex-shrink-0 w-5 h-5 rounded-full bg-alt flex items-center justify-center mt-0.5 mr-3 border border-[#D9D0C1]" data-id="element-33">
                      <Check size={12} className="text-accent" data-id="element-34" />
                    </div>
                    <span className="text-sm text-body" data-id="element-35">{bullet}</span>
                  </li>)}
              </ul>

              <div className="mt-auto pt-4 border-t border-[#D9D0C1]" data-id="element-36">
                <p className="text-xs text-body text-center" data-id="element-37">
                  PDF digital • 12 guiones organizados por situación
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Transition Text */}
        <div className="mt-12 text-center max-w-2xl mx-auto" data-id="element-38">
          <p className="text-lg text-body" data-id="element-39">
            Todo esto (el método + los dos recursos de implementación) por un
            único pago de <span className="font-bold text-title" data-id="element-40">12€</span>. Sin
            suscripciones. Sin renovaciones. Tuyo para siempre.
          </p>
        </div>
      </div>
    </section>;
}